import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  revert(event) {
    event.preventDefault()
    event.params.fields.split(",").forEach(name => {
      const el = this.element.querySelector(`[name="${name}"]`)
      if (el) el.value = ""
    })
  }
}
